import React from 'react';
import { useIsAdmin } from '../../../hooks/useIsAdmin';

/**
 * Route guard: renders children only for admins. Shows a loading state while the
 * role is resolved, and a friendly denial otherwise. Backend routes are also
 * protected per card by requireAccess (10-07) — this is UX, not the security boundary.
 */
export default function RequireAdmin({ children }) {
  const isAdmin = useIsAdmin();
  if (isAdmin === null) {
    return <div className="h-full flex items-center justify-center text-gray-400">Checking access…</div>;
  }
  if (!isAdmin) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-center px-6">
        <h1 className="text-2xl font-bold text-black mb-2">Admins only</h1>
        <p className="text-gray-500">You don&apos;t have access to this page.</p>
      </div>
    );
  }
  return children;
}
